import { Box, Typography, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid2";
import CriSection from "../../components/CriSection";
import {
  LICHEN_GALLERY,
  LichenGalleryType,
} from "../../constants/lichen_gallery";
import { Key } from "react";

const LichenGallery = () => {
  const theme = useTheme();

  return (
    <CriSection alternate={true}>
      <Typography
        sx={{
          fontSize: "36px",
          fontWeight: 500,
          lineHeight: 1,
          textAlign: "center",
        }}
      >
        Gallery
      </Typography>

      <Grid
        container
        spacing={{ xs: 2, md: 4 }}
        sx={{
          marginTop: "36px",
        }}
      >
        {LICHEN_GALLERY.map(
          (lichenPhoto: LichenGalleryType, index: Key | null | undefined) => (
            <Grid size={{ xs: 6, md: 4 }} key={index}>
              <Box
                sx={{
                  backgroundColor: theme.palette.background.paper,
                  borderRadius: "12px",
                  paddingBottom: "12px",
                }}
              >
                <img
                  src={lichenPhoto.image}
                  alt="Lichen"
                  style={{
                    width: "100%",
                    height: "200px",
                    borderTopLeftRadius: "8px",
                    borderTopRightRadius: "8px",
                    objectFit: "cover",
                  }}
                />

                <Typography
                  sx={{
                    marginTop: "6px",
                    fontSize: "14px",
                    fontWeight: 400,
                    textAlign: "center",
                    fontStyle: "italic",
                  }}
                >
                  {lichenPhoto.name}
                </Typography>
              </Box>
            </Grid>
          )
        )}
      </Grid>
    </CriSection>
  );
};

export default LichenGallery;
